export const companyMutationTypes = {
  SET_REQUEST_STATUS: 'SET_REQUEST_STATUS',
  SET_COMPANIES: 'SET_COMPANIES',
  SET_ACTIVE_COMPANY: 'SET_ACTIVE_COMPANY',
};
